module.exports = __webpack_public_path__ + "media/images/switch-off-eba12b07ec9ce7581dc37934d7f48a0a.svg";